import React, { Component, useState, useEffect, useRef } from 'react'
import { Link } from 'react-router-dom';
import Loader from '../Loader/Loader';
import useStateRef from 'react-usestateref';
import { useHistory } from 'react-router-dom';
import Helper from '../Helper';
import { APPLICATION_JSON } from '../../middleware/types';
import { Calendar, DateObject } from 'react-multi-date-picker';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { addYears, getDay } from 'date-fns';
import { useSelector } from 'react-redux';



export const RedeemDelivery = ({ containerObject, templateName, contentId, dataZone }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const [deliveryDetails, setDeliveryDetails, deliveryDetailsRef] = useStateRef('');
    const [curriculam, setCurriculam, curriculamRef] = useStateRef([]);
    const [living, setLiving, livingRef] = useStateRef([])
    const [shippingCheckBox, setShippingCheckBox, shippingCheckBoxRef] = useStateRef({ shipImmediate: 'false', shipLater: 'false' });
    const [arrivalDates, setArrivalDates, arrivalDatesRef] = useStateRef('');
    const [currentEditVoucher, setCurrentEditVoucher, currentEditVoucherRef] = useStateRef('');
    const [currentVoucherCount, setCurrentVoucherCount, currentVoucherCountRef] = useStateRef('')
    const [selectedDate, setSelectedDate, selectedDateRef] = useStateRef('');
    const [curriculamCalenderDetails, setCurriculamCalenderDetails, curriculamCalenderDetailsRef] = useStateRef('');
    const [livingCalenderDetails, setLivingCalenderDetails, livingCalenderDetailsRef] = useStateRef('');
    const [livingDisabledDates, setLivingDisabledDates, livingDisabledDatesRef] = useStateRef([]);
    const [livingActiveDates, setLivingActiveDates, livingActiveDatesRef] = useStateRef('');
    const [curriculamDefaultDate, setCurriculamDefaultDate, curriculamDefaultDateRef] = useStateRef('');
    const [isModalOpen, setModalOpen, isModalOpenRef] = useStateRef(true);
    const [maxDate, setMaxDate, maxDateRef] = useStateRef(addYears(new Date(curriculamDefaultDateRef.current),10));
    const handleCustomCSS = { color: '#690', 'font-size': '12px' }
    const today = new DateObject();
    const [search, setSearch, searchRef] = useStateRef('');
    const dateInputRef = useRef(null);
    const loaderStatus = useSelector(state => state.getLoaderStatus.loaderStatus)
    const isWeekday = (date) => {
        const day = getDay(date);
        return day !== 0 && day !== 6;
      };
  
    useEffect(() => {
        if (loaderStatus == true) {
			console.log("log in redeemDelivery page loader true");
		} else {
			console.log("log in redeemDelivery page loader false");
        setSearch(window.location.pathname)
        // setIsLoading(true)
        if(searchRef.current && searchRef.current.includes('/voucher/delivery')){

            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/redeem/delivery`, {
                method: 'GET'
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        setIsLoading(false);
                        setDeliveryDetails(JSON.parse(res.response).response);
    
                        if (deliveryDetailsRef.current && deliveryDetailsRef.current.curriculum && deliveryDetailsRef.current.curriculum.length > 0) {
                            // setVoucherType('curriculam');
                            setCurriculam(deliveryDetailsRef.current.curriculum);                 
                            // const curriculamArrivalDates = {};
                            curriculamRef.current.map((voucher, index) => {
                                // if (voucher.voucherId) {
                                //     curriculamArrivalDates[voucher.voucherId] = voucher.curriculamDeliverydate;
                                // }
                                if(voucher.defaultDeliverydate){
                                    setCurriculamDefaultDate(voucher.defaultDeliverydate);
                                }
                                if(voucher.shipLaterChecked && voucher.shipImmediateChecked){
                                    setShippingCheckBox({ shipImmediate: voucher.shipImmediateChecked, shipLater: voucher.shipLaterChecked })
                                }
                            })
                            // setArrivalDates(curriculamArrivalDates);
    
    
                        }
                        if (deliveryDetailsRef.current && deliveryDetailsRef.current.living && deliveryDetailsRef.current.living.length > 0) {
                            // setVoucherType('living');
                            setLiving(deliveryDetailsRef.current.living);
                            // const livingArrivalDates = {};
                            // livingRef.current.map((voucher, index) => {
                            //     if (voucher.voucherId) {
                            //         livingArrivalDates[voucher.voucherId] = voucher.livingDeliverydate;
                            //     }
                            // }) 
                            // setArrivalDates(livingArrivalDates);
                            
                        }
    
                        const shippingCheckBoxObj = curriculamRef.current.find(obj => obj.shipLaterChecked !== undefined);
                        const shipLater = shippingCheckBoxObj ? shippingCheckBoxObj.shipLaterChecked : false;
                        const shipImmediate = shippingCheckBoxObj ? shippingCheckBoxObj.shipImmediateChecked : false;
                
                        
                    } else {
                        setIsLoading(false)
                        const error = res._ERROR_MESSAGE_;
                    }
                })
        }
        document.querySelector('#calendar-modal').addEventListener('hidden.bs.modal', function (e) {
            setModalOpen(false);
            setModalOpen(true);
        })
    }
    }, [])
 
    async function handleSetArrivalDate(date) {
        document.getElementById('calendar-modal-close')?.click();
        const formatter = new Intl.DateTimeFormat('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
        const formattedDate = formatter.format(new Date(selectedDateRef.current));
        new Date(selectedDateRef.current).getMonth(new Date(selectedDateRef.current))
        var actionUrl = "/api/rest/cb/redeem/edit-arrival-date";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var inputMap = { "vCount": currentVoucherCountRef.current, "selectedDate": formattedDate , "type":currentEditVoucherRef.current?.type};
        inputMap = JSON.stringify(inputMap);
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
        if (res.response != null) {
            setDeliveryDetails(JSON.parse(res.response).response);

            if (deliveryDetailsRef.current && deliveryDetailsRef.current.curriculum && deliveryDetailsRef.current.curriculum.length > 0) {
               
                setCurriculam(deliveryDetailsRef.current.curriculum);
                // const curriculamArrivalDates = {};
                //         curriculamRef.current.map((voucher, index) => {
                //             if (voucher.voucherId) {
                //                 curriculamArrivalDates[voucher.voucherId] = voucher.curriculamDeliverydate;
                //             }
                //         })
        
                    //    setArrivalDates(curriculamArrivalDates);
            }
            if (deliveryDetailsRef.current && deliveryDetailsRef.current.living && deliveryDetailsRef.current.living.length > 0) {
              
                setLiving(deliveryDetailsRef.current.living);
                // const livingArrivalDates = {};
                //         livingRef.current.map((voucher, index) => {
                //             if (voucher.voucherId) {
                //                 livingArrivalDates[voucher.voucherId] = voucher.livingDeliverydate;
                //             }
                //         })
                   //   setArrivalDates(livingArrivalDates);
            }
           
        } else {
            console.log('res.response...', res.response);
        }
    }
    async function handleCheckShipping(event) {
        if (event.target.getAttribute('name') === 'shipLater') {
            var inputMap = { "shipType": "false", "isChanged": "true" }
            setShippingCheckBox({ shipImmediate: 'false', shipLater: 'true' });
        }
        if (event.target.getAttribute('name') === 'shipImmediate') {
            var inputMap = { "shipType": "true", "isChanged": "true" }
            setShippingCheckBox({ shipImmediate: 'true', shipLater: 'false' });
        }
        var actionUrl = "/api/rest/cb/redeem/update-shipping-method";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`

        inputMap = JSON.stringify(inputMap);
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)

        setDeliveryDetails(JSON.parse(res.response).response);

            if (deliveryDetailsRef.current && deliveryDetailsRef.current.curriculum && deliveryDetailsRef.current.curriculum.length > 0) {
                // setVoucherType('curriculam');
                setCurriculam(deliveryDetailsRef.current.curriculum);
                // const curriculamArrivalDates = {};
                        curriculamRef.current.map((voucher, index) => {
                            // if (voucher.voucherId) {
                            //     curriculamArrivalDates[voucher.voucherId] = voucher.curriculamDeliverydate;
                            // }
                            if(voucher.defaultDeliverydate){
                                setCurriculamDefaultDate(voucher.defaultDeliverydate);
                            }
                        })
        
                    //    setArrivalDates(curriculamArrivalDates);
            
        } else {
            console.log('res.response...', res.response);
        }

    }

    const handleContinue = (event) => {
        event.preventDefault();
        if (deliveryDetailsRef.current) {
            history.push("/voucher/review")
        }
    }
    
    async function handleEditCalender (voucher, vCount, deliveryDate, event)  {
        event.preventDefault();
        setSelectedDate(deliveryDate);
        const currentMonth = new Date().getMonth(new Date());
        const selectedYear = new Date().getFullYear(selectedDateRef.current);
        var elements = document.getElementsByTagName('option');
        if(new Date().getFullYear(new Date()) == new Date(selectedDateRef.current).getFullYear(new Date(selectedDateRef.current))){
            for(var i=0;i<currentMonth;i++){
                elements[i]?.classList.add('d-none')
            }
        }
        voucher.voucherId && setCurrentEditVoucher(voucher);
        setCurrentVoucherCount(vCount);
        isModalOpenRef.current && handleMonthAndYearChange(new Date(selectedDateRef.current), true);
        var actionUrl = 'api/rest/cb/redeem/get-calender-details'
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}?count=${vCount}&editType=apply&vtype=${voucher.type}&defaultDate=''&sessionDate=${currentEditVoucherRef.current.type ==='LV'?voucher.livingDeliverydate:voucher.curriculamDeliverydate}`;
        var res = await Helper.fetchCallFunction(url, "GET", false, APPLICATION_JSON, null)
        var response = JSON.parse(res.response).response;
        if (res.response != null) {
            if(voucher.type === 'CLV' || voucher.type === 'TWG' || voucher.type === 'CPV'){
                setCurriculamCalenderDetails(response);
                var calenderElements = document.getElementsByClassName('react-datepicker__current-month');
                if(calenderElements[0] || calenderElements[3]){
                    calenderElements[0].classList.add('d-none');
                    calenderElements[3].classList.add('d-none');
                }
            
            }else{
                setLivingCalenderDetails(response);
                const disableDates = livingCalenderDetailsRef.current? livingCalenderDetailsRef.current.bodDateList:'';
                setLivingDisabledDates(disableDates.split(' '));
                const activeDates = livingCalenderDetailsRef.current? livingCalenderDetailsRef.current.sdaDateList:'';
                setLivingActiveDates(activeDates.split(' '));
            }
            
        } else {
            console.log('response...', res.response);
        }
    }
    const handleMonthAndYearChange = (date, isFromEditCalender)=>{
        const currentMonth = new Date().getMonth(new Date(curriculamDefaultDateRef.current));	
        var elements = document.getElementsByTagName('option');
        if(date.getFullYear(date) == new Date().getFullYear(new Date())){
            for(var i=0;i<=elements.length;i++){
                if(elements?.[i]?.value<currentMonth){
                    elements?.[i]?.classList.add('d-none');
                }
                else if(elements?.[i]?.value==currentMonth){
                    elements?.[i]?.setAttribute('selected','selected');
                }
               
            }
		}else{
            for(var i=0;i<=elements.length;i++){
                if(elements?.[i]?.value<currentMonth){
                elements?.[i]?.classList.remove('d-none')
                }
            }
        }
        if(!isFromEditCalender){
            var selectedYear = new Date(date).getFullYear(date)
        }else{
            var selectedYear = new Date(selectedDateRef.current).getFullYear()
        }
		var currentYear = new Date(curriculamDefaultDateRef.current).getFullYear()
		if (selectedYear < currentYear + 10) {
			const maxDate = addYears(
				new Date(curriculamDefaultDateRef.current),
				selectedYear + 10 - currentYear
			)
            elements = document.getElementsByTagName('option');
			Object.entries(elements).map(([key, value]) => {
				if(value.value <= selectedYear && value.value >= currentYear){
                    value.classList.remove('d-none');
					value.classList.add('d-block');
				}	
                if(value.value > selectedYear + 10){
                    value.classList.add('d-none');
                }
			})
            

			setMaxDate(maxDate)
		} else if (selectedYear == currentYear + 10) {
			const maxDate = addYears(new Date(curriculamDefaultDateRef.current), 20)
			setMaxDate(maxDate)
            Object.entries(elements).map(([key, value]) => {
				if(value.value <= selectedYear && value.value >= currentYear){
                    value.classList.remove('d-none');
					value.classList.add('d-block');
				}
			
				
			})
		} else if (selectedYear > currentYear + 10) {
			const maxDate = addYears(
				new Date(curriculamDefaultDateRef.current),
				selectedYear + 10 - currentYear
			)

			setMaxDate(maxDate)
            elements = document.getElementsByTagName('option');
			Object.entries(elements).map(([key, value]) => {
				if(value.value < selectedYear - 10 && value.value >= currentYear){
					value.classList.add('d-none');
				}
                if(value.value >= selectedYear - 10 && value.value >= currentYear){
					value.classList.remove('d-none');
                    value.classList.add('d-block');
				}
			
				
			})
		}
      
        if(isFromEditCalender && isModalOpenRef.current){
            elements = document.getElementsByTagName('option');
         Object.entries(elements).map(([key, value]) => {
				if(value.value <= maxDateRef.current.getFullYear(maxDateRef.current) && value.value >= currentYear && value.value >= selectedYear - 10){
                    value.classList.remove('d-none');
					value.classList.add('d-block');
				}else if(value.value >= currentYear && value.value <= selectedYear - 10){
                    value.classList.add('d-none');
                }
			})
        }


    }

    async function handleApplyToAll(deliveryDate, vType){
        var actionUrl = "/api/rest/cb/redeem/edit-arrival-date";
        var url = `${window.location.protocol}//${window.location.hostname}/${actionUrl}`
        var inputMap = { "vCount": 0, "selectedDate": deliveryDate, "type":vType};
        inputMap = JSON.stringify(inputMap);
        var res = await Helper.fetchCallFunction(url, "POST", false, APPLICATION_JSON, inputMap)
        if (res.response != null) {
            setDeliveryDetails(JSON.parse(res.response).response);

            if (deliveryDetailsRef.current && deliveryDetailsRef.current.curriculum && deliveryDetailsRef.current.curriculum.length > 0) {
                // setVoucherType('curriculam');
                setCurriculam(deliveryDetailsRef.current.curriculum);
                // const curriculamArrivalDates = {};
                //         curriculamRef.current.map((voucher, index) => {
                //             if (voucher.voucherId) {
                //                 curriculamArrivalDates[voucher.voucherId] = voucher.curriculamDeliverydate;
                //             }
                //         })
        
                    //    setArrivalDates(curriculamArrivalDates);
            }
            if (deliveryDetailsRef.current && deliveryDetailsRef.current.living && deliveryDetailsRef.current.living.length > 0) {
                // setVoucherType('living');
                setLiving(deliveryDetailsRef.current.living);
                // const livingArrivalDates = {};
                //         livingRef.current.map((voucher, index) => {
                //             if (voucher.voucherId) {
                //                 livingArrivalDates[voucher.voucherId] = voucher.livingDeliverydate;
                //             }
                //         })
                    //  setArrivalDates(livingArrivalDates);
            }
            document.getElementById('calendar-modal-close').click();
           
        } else {
            console.log('res.response...', res.response);
        }
    }
    return (<>
        <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content c-shop-list-detail`} >
            {isLoading && <Loader />}
            <div class="row justify-content-center c-school-page c-steps-page">
                <div class="col-12 col-md-11 my-5 c-steps-pd">
                    {livingRef.current && livingRef.current.length > 0 &&
                        <div class="cb-voucher-delivery" id="lvSection">
                            <div class="row">
                                <div class="col-md-12 text-left mb-4">
                                    <h1 class="c-account-heading mb-2">Your Living Voucher Items</h1>
                                </div>
                            </div>
                            <div class="row mb-2 px-md-5 ">
                                <div class="col-12 col-md-5">
                                    <p class="text-left mb-2 c-delivery-text"></p>
                                </div>
                                <div class="col-12 col-md-4 d-none d-md-block">
                                    <p class="text-left mb-2 c-delivery-text">Arrival Date</p>
                                </div>
                            </div>
                            {livingRef.current.map((voucher, index) => {
                                return (
                                    <>
                                        {voucher.voucherId && <div class="row mb-md-5 mb-4 px-md-4 align-items-start c-voucher-space">
                                            <div class="col-12 col-md-5">
                                                <div class="c-delivery-item">
                                                    <div class="c-delivery-items">
                                                        <p class="text-left mb-0 c-delivery-content">Code:   {voucher.voucherId}</p>

                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-5 align-items-center d-flex delivery">
                                                <p class="text-left mb-0 c-delivery-text d-md-none fw-normal">{voucher.ArrivalDateTitle && voucher.ArrivalDateTitle}: &nbsp;</p>
                                                <div class="me-2 me-md-4">
                                                    <p class="text-left mb-0 c-delivery-content c-date-bold">{voucher.livingDeliverydate && voucher.livingDeliverydate}</p>
                                                </div>
                                                {/* <p id="edit-calender" data-bs-toggle="modal" data-bs-target="#calendar-modal" data-bs-dismiss="modal" title="" class="fwb icon-content m-0"></p> */}
                                                <Link to="#calendar-modal" onClick={(event) => {handleEditCalender(voucher, voucher.vCount, voucher.livingDeliverydate, event);}} data-bs-toggle="modal" class="btn btn-outline-secondary ms-1 ms-md-3 cb-edit-btn modal-link">edit</Link>
                                                {livingRef.current.length > 1 && !deliveryDetailsRef.current.isLeadDaysAvailable &&
                                                    <Link onClick={() => handleApplyToAll(voucher.livingDeliverydate,'LV')} class="btn btn-outline-secondary ms-1 ms-md- cb-edit-btn ">{curriculamRef.current?.length > 0 ? 'apply to all living':'apply to all'}</Link>
                                                }

                                            </div>
                                        </div>

                                        }
                                    </>
                                )
                            }
                            )}
                        </div>
                    }
                    {curriculamRef.current && curriculamRef.current.length > 0 &&
                        <div id='cvSection' className='cb-voucher-delivery'>
                            <div className='row'>
                                <div className='col-md-12 text-left mb-4'>
                                    <div className='c-account-heading mb-2'>
                                        Your Redemption Items
                                    </div>
                                </div>
                            </div>
                            <div className='row px-md-4'>
                                <div className='col-12 col-md-12 text-left mb-2 mb-md-0'>
                                    <h1 className='c-account-heading'>Select your shipping preference:</h1>
                                </div>

                            </div>



                            <div class="row g-4 px-md-4 py-md-4 mb-5">
                                <div class="col-12 col-md-5">
                                    <div class= {shippingCheckBoxRef.current && shippingCheckBoxRef.current.shipImmediate === 'true'?'c-box-shipping active':'c-box-shipping'}>
                                        <div class="form-check">
    
                                            <input class="form-check-input" 
                                            type="radio" 
                                            name="shipImmediate" 
                                            checked={shippingCheckBoxRef.current && shippingCheckBoxRef.current.shipImmediate === 'true'?'true':''}
                                            id="shipImmediate" 
                                            onChange={handleCheckShipping} />
                                            <label class="form-check-label fw-bold" for="shipImmediate">
                                                Ship Immediately
                                            </label>
                                            
                                        </div>
                                        {shippingCheckBoxRef.current && shippingCheckBoxRef.current.shipImmediate === 'true' &&                                       
                                        <div class="container-circle">
                                            <div class="circle">
                                            </div>
                                        </div>
                                        } 

                                    </div>
                                </div>

                                <div class="col-12 col-md-5">
                                    <div class={shippingCheckBoxRef.current && shippingCheckBoxRef.current.shipLater === 'true'?'c-box-shipping active':'c-box-shipping'}>
                                        <div class="form-check">

                                            <input class="form-check-input" 
                                            checked={shippingCheckBoxRef.current && shippingCheckBoxRef.current.shipLater === 'true'?'true':''} 
                                            type="radio" 
                                            name="shipLater" 
                                            id="shipLater"                     
                                            onChange={handleCheckShipping} />
                                            <label class="form-check-label fw-bold" for="shipLater">
                                                Ship at a Later Time
                                            </label>
                                           
                                        </div>
                                        {shippingCheckBoxRef.current && shippingCheckBoxRef.current.shipLater === 'true' &&                                       
                                        <div class="container-circle">
                                            <div class="circle">
                                            </div>
                                        </div>
                                        } 
                                    </div>
                                </div>
                            </div>

                            <div class="row mb-2 px-md-5 ">
                                <div class="col-12 col-md-5">
                                    <p class="text-left mb-2 c-delivery-text"></p>
                                </div>
                                <div class="col-12 col-md-4 d-none d-md-block">
                                    <p class="text-left mb-2 c-delivery-text">Arrival Date</p>
                                </div>
                            </div>


                            {curriculamRef.current.map((voucher, index) => {
                                return (
                                    <>
                                        {voucher.voucherId && <div class="row mb-md-5 mb-4 px-md-4 align-items-start c-voucher-space">
                                            <div class="col-12 col-md-5">
                                                <div class="c-delivery-item">
                                                    <div class="c-delivery-items">
                                                        <p class="c-delivery-item-text">Code: &nbsp;{voucher.voucherId && voucher.voucherId}</p>
                                                        <p class="c-delivery-item-text">{voucher.schoolName && voucher.schoolName}</p>
                                                        <p class="c-delivery-item-text">{voucher.courseTitle && voucher.courseTitle}</p>
                                                        <p class="c-delivery-item-text">{voucher.courseId && voucher.courseId}</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-5 align-items-center d-flex delivery">
                                                <p class="text-left mb-0 c-delivery-text d-md-none fw-normal">{voucher.ArrivalDateTitle && voucher.ArrivalDateTitle}: &nbsp;</p>
                                                <div class="me-2 me-md-4">
                                                    <p class="text-left mb-0 c-delivery-content c-date-bold">{voucher.curriculamDeliverydate && voucher.curriculamDeliverydate}</p>
                                                </div>
                                                {
                                                    shippingCheckBoxRef.current && shippingCheckBoxRef.current.shipLater === 'true' ? <Link to="#calendar-modal" onClick={(event) => handleEditCalender(voucher, voucher.vCount,voucher.curriculamDeliverydate, event)} data-bs-toggle="modal" class="btn btn-outline-secondary ms-1 ms-md-3 cb-edit-btn modal-link">edit</Link> : ''
                                                }
                                                 {curriculamRef.current.length > 2 && shippingCheckBoxRef.current && shippingCheckBoxRef.current.shipLater === 'true' &&
                                                    <Link onClick={() => handleApplyToAll(voucher.curriculamDeliverydate,'CLV')} class="btn btn-outline-secondary ms-1 ms-md- cb-edit-btn "> {livingRef.current?.length > 0 ? 'apply to all redemption' : 'apply to all'}</Link>
                                                }

                                            </div>
                                        </div>
                                        }
                                    </>
                                )
                            }
                            )}
                        </div>
                    }


                    <div class="row g-0 g-md-5 g-md-5 redeem-delivery-continue mb-3 my-md-3">
                        <div class="col-md-4 d-grid cb-form-section">
                            <button onClick={(event)=>{handleContinue(event)}} class="btn btn-primary block redeem-btn">Continue</button>
                        </div>
                    </div>
                </div>
            </div>
           
            <div className="modal fade c-modal p-0 m-0" id="calendar-modal" tabindex="-1" aria-labelledby="defaultModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down modal-lg-a">
                    <div className="modal-content">
                        <button type="button" id="calendar-modal-close" onMouseDown={()=>handleSetArrivalDate(selectedDateRef.current)} className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                        </button>
                         {isModalOpenRef.current &&
                        <div className="modal-body redeem-calender">
                            <h1> Choose an Arrival Date<br /></h1>
                            {currentEditVoucherRef.current && currentEditVoucherRef.current.type ==='LV'?
                                <ul className='calendar-key'>
                                    <li className='calendar-2da'>{livingCalenderDetailsRef.current?livingCalenderDetailsRef.current.shipMethodMsg:''}</li>
                                </ul>:''
                            }
                            
                            <p>{currentEditVoucherRef.current && currentEditVoucherRef.current.type ==='LV'?livingCalenderDetailsRef.current &&livingCalenderDetailsRef.current.livingModalMsg: currentEditVoucherRef.current && currentEditVoucherRef.current.type ==='CLV'? curriculamCalenderDetailsRef.current&&curriculamCalenderDetailsRef.current.bodyMsg:''} 
                            </p>
                            {currentEditVoucherRef.current.type ==='LV'?
                            <p>Your currently selected date is highlighted below. Click any bold date to change your selection. The date's color (see Shipping Key) indicates the shipping method that we will use to ensure delivery on your date.</p>:''}
                           
                                            {currentEditVoucherRef.current.type ==='LV'?  
                                                <> 
                                                <Calendar numberOfMonths={3} 
                                                        mapDays={({ date }) => {
                                                                    let isWeekend =   currentEditVoucherRef.current.type ==='LV'?
                                                                    [0, 1, 2, 6].includes(date.weekDay.index)
                                                                    :
                                                                    [0, 6].includes(date.weekDay.index);
                                                                    const formatter = new Intl.DateTimeFormat('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
                                                                    const formattedDate = formatter.format(date);
                                               
                                                                    if ((livingActiveDatesRef.current && !livingActiveDatesRef.current.includes(formattedDate))||(livingDisabledDatesRef.current && livingDisabledDatesRef.current.includes(formattedDate))||isWeekend) {
                                                                    return {
                                                                        disabled: true,
                                                                        style: { color: '#ccc' },                     
                                                                    }} 
                                                                }
                                                        }    
                                                        minDate={new Date()}                     
                                                        format="MM/DD/YYYY" 
                                                        style={handleCustomCSS} value={selectedDateRef.current} 
                                                        onChange={setSelectedDate}
                                                        onFocusedDateChange={handleSetArrivalDate} 
                                                        weekDays={['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']}
                                                        className='living-multi-date-picker'
                                                />
                                                <Calendar 
                                                        mapDays={({ date }) => {
                                                                    let isWeekend =   currentEditVoucherRef.current.type ==='LV'?
                                                                    [0, 1, 2, 6].includes(date.weekDay.index)
                                                                    :
                                                                    [0, 6].includes(date.weekDay.index);
                                                                    const formatter = new Intl.DateTimeFormat('en-US', { day: '2-digit', month: '2-digit', year: 'numeric' });
                                                                    const formattedDate = formatter.format(date);
                                               
                                                                    if ((livingActiveDatesRef.current && !livingActiveDatesRef.current.includes(formattedDate))||(livingDisabledDatesRef.current && livingDisabledDatesRef.current.includes(formattedDate))||isWeekend) {
                                                                    return {
                                                                        disabled: true,
                                                                        style: { color: '#ccc' },                     
                                                                    }} 
                                                                }
                                                        }   
                                                        minDate={new Date()}                 
                                                        format="MM/DD/YYYY" 
                                                        style={handleCustomCSS} value={selectedDateRef.current} 
                                                        onChange={setSelectedDate}
                                                        onFocusedDateChange={handleSetArrivalDate} 
                                                        weekDays={['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']}
                                                       // className='d-none d-sm-block d-md-none'
                                                       className='living-single-date-picker'
                                                />
                                                
                                                </> 
                                                :
                                                <>
                                          <section className='cb-voucher-calendar'>
                                <div id='datepickers' className='hasDatepicker'>
                                    <div className='ui-datepicker-inline ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all ui-datepicker-multi ui-datepicker-multi-3'>
                                        <div className='ui-datepicker-group ui-datepicker-group-first curriculam-multi-date-picker'>
                                           
                                                        <DatePicker
                                                        ref={dateInputRef}
                                                        className='curriculam-multi-date-picker'
                                                        selected={ selectedDateRef.current ? new Date(selectedDateRef.current) : new Date()}
                                                        onChange={setSelectedDate}
                                                        onSelect={handleSetArrivalDate}
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        showYearDropdown
                                                        showPreviousMonths={false}
                                                        dropdownMode="select"
                                                        monthsShown={ 3 }
                                                        inline
                                                        dateFormat="MM/DD/yyyy"
                                                        peekNextMonth={false}
                                                        minDate={new Date(curriculamDefaultDateRef.current)}
                                                        maxDate={maxDateRef.current}
                                                        filterDate={isWeekday}
                                                        shouldCloseOnSelect={false}
                                                        focusSelectedMonth={true}
                                                        showDisabledMonthNavigation={false}
                                                        onYearChange={handleMonthAndYearChange}
                                                        onMonthChange={handleMonthAndYearChange}
                                                      
                                                    />
                                        </div>
                                        <div className='ui-datepicker-group ui-datepicker-group-first curriculam-single-date-picker'>
                                            {/* <div className='ui-datepicker-header ui-widget-header ui-helper-clearfix ui-corner-left'>
                                                <a className='ui-datepicker-prev ui-corner-all ui-state-disabled' title='Prev'>
                                                    <span className='ui-icon ui-icon-circle-triangle-w'></span>
                                                </a> 
                                            </div>   */}
                                                    <DatePicker
                                                        className='curriculam-single-date-picker'
                                                        selected={ selectedDateRef.current ? new Date(selectedDateRef.current) : new Date()}
                                                        onChange={setSelectedDate}
                                                        onSelect={handleSetArrivalDate}
                                                        showMonthDropdown
                                                        useShortMonthInDropdown
                                                        showYearDropdown
                                                        showPreviousMonths={false}
                                                        dropdownMode="select"
                                                        monthsShown={1}
                                                        inline
                                                        dateFormat="MM/DD/yyyy"
                                                        peekNextMonth={false}
                                                        minDate={new Date(curriculamDefaultDateRef.current)}
                                                        maxDate={maxDateRef.current}
                                                        filterDate={isWeekday}
                                                        shouldCloseOnSelect={false}
                                                        focusSelectedMonth={true}
                                                        showDisabledMonthNavigation={false}
                                                        onYearChange={handleMonthAndYearChange}
                                                        onMonthChange={handleMonthAndYearChange}
                                                        
                                                    />
                                        </div>
                                    </div>
                                </div>
                            </section>
                            </>
                                }
                        </div>}
                     
                    </div>
                </div>
            </div>
        </div>
    </>
    )
}
